import { DocumentExtractionMetaType } from '@/modules/ai/constants/DocumentExtractionMetaType';
import { DocumentExtractionBankStatementMeta } from '@/modules/ai/models/meta/DocumentExtractionBankStatementMeta';

export class DocumentExtractionMetaFactory {
  static build(
    metaType: DocumentExtractionMetaType | undefined,
    model = {}
  ): DocumentExtractionBankStatementMeta | undefined {
    switch (metaType) {
      case DocumentExtractionMetaType.DOCUMENT_EXTRACTION_BANK_STATEMENT_META:
        return new DocumentExtractionBankStatementMeta(model);
      default:
        return undefined;
    }
  }
}
